export const scrollToPageTop = () => {
    if (typeof window === 'undefined' || typeof window.scrollTo !== 'function') return false;

    const scroll = () => window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(scroll);
    } else {
        scroll();
    }

    return true;
};
